<template>
    <stats-card
            :title="amountOfDids"
            sub-title="Phone numbers"
            type="primary"
            icon="fal fa-phone"
    >
        <div slot="footer" v-on:click="refreshData" class="refreshSlot">
            <font-awesome-icon :icon="['fal','redo']" spin v-bind:spin=isLoading></font-awesome-icon>
            Update Now
        </div>
    </stats-card>
</template>

<script>
    import StatsCard from '../../components/Cards/StatsCard';

    export default {
        components: {
            StatsCard
        },
        name: "DIDCard",
        data() {
            return {};
        },
        computed: {
            isLoading: function () {
                return this.$store.getters['did/isLoading'];
            },
            DIDs: function () {
                return this.$store.getters['did/uniqueDIDs'];
            },
            amountOfDids: function () {
                return '' + this.DIDs.length;
            }
        },
        mounted() {
            if (this.$store.getters['did/needUpdate']) {
                // noinspection JSIgnoredPromiseFromCall
                this.refreshData();
            }

        },
        methods: {
            refreshData() {
                if (this.isLoading === false) {
                    // noinspection JSIgnoredPromiseFromCall
                    this.$store.dispatch('did/loadUniqueDIDs');
                }
            }
        }
    }
</script>

<style scoped>
    .refreshSlot {
        cursor: pointer;
    }
</style>